export default __webpack_public_path__ + "static/media/dep3_5.26c4a2d0.png";